module.exports = __webpack_public_path__ + "img/chart.16e0855c.png";